import { mutationTypes } from '@/core/constants'

export default class LoadingScreen {
	constructor(store) {
		this.store = store
	}

	start() {
		const { executarSemLoading, requisicoesPendentes } = this.store.state.comum

		if (!executarSemLoading || (executarSemLoading && requisicoesPendentes > 0)) {
			this.store.commit(mutationTypes.COMUM.INCREMENT_REQUESTS_IN_PROGRESS)
		}
	}

	stop() {
		const { executarSemLoading, requisicoesPendentes } = this.store.state.comum

		if (!executarSemLoading || (executarSemLoading && requisicoesPendentes > 0)) {
			this.store.commit(mutationTypes.COMUM.DECREMENT_REQUESTS_IN_PROGRESS)
		}
	}

	reset() {
		this.store.commit(mutationTypes.LOKI.SET_LOADING_MESSAGE, this.store.state.defaultLoadingMessage)
	}

	mostrarFalhaSalvamentoAutomaticoSeAtivo() {
		if (this.store.state.loki.autoSave.saving) {
			this.store.commit(mutationTypes.COMUM.MOSTRAR_FALHA_SALVAMENTO_AUTOMATICO)
		}
	}
}
